import MODULES from "@config/Modules/Shared/modules";
import getModuleName from "@helpers/modules";
import EyeIcon from "mdi-react/EyeOutlineIcon";
import ListIcon from "mdi-react/FormatListBulletedIcon";
import EditIcon from "mdi-react/PencilCircleOutlineIcon";
import PlusIcon from "mdi-react/PlusCircleOutlineIcon";
import { ReactElement } from "react";
import { useLocation } from "react-router-dom";
import { Col, Row } from "reactstrap";

type TTitleInfo = {
  [key: string]: {
    icon: JSX.Element;
    state: string;
  };
};

const Title = (): ReactElement => {
  const { pathname } = useLocation();

  const getSectionName = () =>
    Object.keys(MODULES).filter((section) => pathname.includes(section))[0];

  const getAction = () => {
    const actions = ["create", "detail", "modify", "list"];

    const titleInfo: TTitleInfo = {
      list: {
        icon: <ListIcon />,
        state: "",
      },
      create: {
        icon: <PlusIcon />,
        state: "Create",
      },
      detail: {
        icon: <EyeIcon />,
        state: "Detail",
      },
      modify: {
        icon: <EditIcon />,
        state: "Modify",
      },
    };

    const state = actions.filter((state) => pathname.includes(state));

    return titleInfo[state[0]];
  };

  return (
    <Row>
      <Col>
        <h3 className="page-title">
          {getAction().icon}{" "}
          {getSectionName() !== undefined && `${getSectionName()} |`}{" "}
          {getModuleName(pathname)}
          {getAction().state !== "" && ` | ${getAction().state}`}
        </h3>
      </Col>
    </Row>
  );
};

export default Title;
